/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IConnectedBlocksMap = Application.Models.IConnectedBlocksMap;

    /**
     * VideoPlayerModalController class
     */
    export class TakeAllModalController {
        public static templateUrl: string = "decorators/modals/take-all-modal.html";
        public static ID: string = "#id-take-all-modal";
        public static $name: string = "takeAllModal";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'takeInputs',
                                           'connectedBlocks',
                                           'connectionRoomService',
                                           '$q',
                                           '$rootScope'
                                           ];

        private scope: ITakeAllModalScope;
        private close: (userAction: boolean) => void;

        /**
         * Constructor
         */
        constructor($scope: ITakeAllModalScope,
                    close: () => void,
                    takeInputs: ITakeAllModalInput,
                    connectedBlocks: IConnectedBlocksMap,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private $q: ng.IQService,
                    private $rootScope: Services.IFlexSettings) {
            this.scope = $scope;
            this.scope.THUMBNAIL_FAIL_IMG = "images/thumbnail-fail.png";
            this.scope.takeModalInput = takeInputs;
            this.scope.connectedBlocks = connectedBlocks;
            this.scope.messageType = undefined;
            this.scope.validationIsTakingTooLongMessage = "This is taking longer than usual. You might have a connectivity problem.";
            this.close = close;
            this.scope.ready = false;
            this.scope.drop = takeInputs.drop;

            this.scope.dropLock = (): void => {
                this.connectionRoomService.cancelValidation();
                    this.connectionRoomService.dropLock();
                this.$rootScope.$broadcast('vars.connectionLocked', false);
                this.scope.modalClose(false);

            };

            /**
             * when closing modal, we send presetPath info in case there is one, otherwise, send userResponse 
             *  (boolean to check if modal is closed by clicking on continue button)
             */
            this.scope.modalClose = (userResponse: boolean): void => {
                this.close(userResponse);
            };

            this.validateAll();
        }

        async validateAll(){
            let selectedConnectionRoomGroup = this.scope.takeModalInput.selectedConnectionRoomGroup;
            let promiseArray: ng.IPromise<any>[] = [];
            selectedConnectionRoomGroup.blocksInfo.forEach( (block)=> {
                promiseArray.push(this.validateBlock(block.id));
            } );
            Promise.all(promiseArray).then((values: any) => {
                let error: boolean = values.some((validation:any) => {
                    this.scope.warningMessage = validation.result != 'OK' && validation.result != 'WARNING' ? validation.message : '';
                   return validation.result != 'OK' && validation.result != 'WARNING'
                });
                if(!error){
                    this.scope.connectionValid = true;
                    this.$rootScope.$broadcast('vars.connectionLocked', true);
                }else{
                    this.scope.connectionValid = false;
                }

                this.scope.ready = true;
              });             
        }

        private validateBlock(blockId: number): ng.IPromise<Models.IConnectionValidation> {
            let prevSrc: Models.IConnectedBlock =
              this.scope.connectedBlocks[blockId] ? this.scope.connectedBlocks[blockId][0] : undefined;
            if (!this.scope.drop && prevSrc) {
                let result: Models.IConnectionValidation = {
                    result: 'ERROR',
                    message: 'Some of the blocks already have an existing connection. Please drop those connections to perform the take all.',
                    data: undefined,
                    params: undefined
                }
                return this.$q.resolve(result);
            } else
                return this.connectionRoomService.validateConnection(this.scope.takeModalInput.src.id, blockId, undefined);
        }
    }   
}
